import { latLngBounds, latLng } from "leaflet";
import {maps} from "@/store";

const  bboxFilter = (featureArray:any[], geoField:string) => {
  const bbox = maps.getters.mapBounds;
  const bounds = latLngBounds(bbox.getSouthWest(), bbox.getNorthEast());
  return featureArray.filter((feature) => {
    const geom = feature[geoField].coordinates;
    const coords = latLng(geom[1], geom[0]);
    return bounds.contains(coords);
  });
};

export default bboxFilter
